import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import CustomCarousel from "../helpers/CustomCarousel";
import { apiurl } from "../services/authServices";
import { Box, Typography } from "@mui/material";
import Marquee from "react-fast-marquee";

const DashboardMap = () => {
  const location = useLocation();
  const { id, pass } = location.state || {};
  const [sliderData, setSliderData] = useState("");
  const [apiCallCheck, setApiCallCheck] = useState(true);
  const [time, setTime] = useState(600000);

  const apiCall = async (sliderData) => {
    try {
      const response = await axios.post(`${apiurl}/api/getpost`, {
        screenCode: id,
        machineCode: pass,
      });
      // console.log(JSON.stringify(sliderData) !== JSON.stringify(response.data.data))
      if (JSON.stringify(sliderData) !== JSON.stringify(response.data.data)) {
        console.log("inside");
        setSliderData(response.data.data);
      }
    } catch (error) {
      console.error("err=>>", error);
    }
  };

  const apiCallCheckFun = () => {
    setApiCallCheck(!apiCallCheck);
  };

  useEffect(() => {
    apiCall(sliderData);
    const intervalId = setInterval(apiCallCheckFun, time);
    return () => clearInterval(intervalId);
  }, [apiCallCheck]);

  return (
    <>
      {/* <Box
        sx={{
          backgroundColor: "#f0f0f0", // Optional: background color
          padding: "10px 0", // Optional: padding
          overflow: "hidden",
        }}
      >
        <Marquee speed={50} pauseOnHover>
          <Typography variant="body1" component="span">
            Cloud marketing is the process of an organization's efforts to
            market their goods and services online through integrated digital
            experiences, by which they are specialized for every end-user
          </Typography>
          <Typography variant="body1" component="span" sx={{ marginLeft: 2 }}>
            Thanks
          </Typography>
        </Marquee>
      </Box> */}
      {sliderData && <CustomCarousel data={sliderData} />}
      <Box
        sx={{
          backgroundColor: "#f0f0f0", // Optional: background color
          padding: "10px 0", // Optional: padding
          overflow: "hidden",
        }}
        style={{ position: "absolute", bottom: 0 }}
      >
        <Marquee speed={50} pauseOnHover>
          <Typography variant="body1" component="span">
            Skycast marketing is the process of an organization's efforts to
            market their goods and services online through integrated digital
            experiences, by which they are specialized for every end-user
          </Typography>
          <Typography variant="body1" component="span" sx={{ marginLeft: 2 }}>
            Thanks
          </Typography>
        </Marquee>
      </Box>
    </>
  );
};
export default DashboardMap;
